// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-header .navbar-nav .dropdown-menu-right {\n  right: inherit;\n}\n\n/* Remove default padding inherited from b-dropdown-form. */\n#locale-picker-form {\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
